import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { TaxEditComponent } from 'app/common/tax/tax-edit.component';
import { GeneralSettings } from 'app/profile/models/generic.model';
import { Country } from 'app/profile/models/masterdata.model';
import { OnboardingDocument } from 'app/profile/models/onboarding.model';
import { Currency, DataWithSupplierCode, OPERATION, SupplierDocument, SupplierTax, SupplierTaxPropertyValues } from 'app/profile/models/supplier.model';
import { SupplierTaxInfo, TaxCountryConfig, TaxIDType } from 'app/profile/models/tax.model';
import { SupplierProfileState } from 'app/profile/store/app.reducer';
import { TaxState } from 'app/profile/store/state/tax.state';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from '../../base.component';
import * as TaxActions from "../../../store/actions/tax.actions";
import * as TaxSelectors from "../../../store/selectors/tax.selectors";
import * as GeneralActions from "../../../store/actions/general.action";
import * as GeneralSelectors from "../../../store/selectors/general.selector";
import * as MasterDataActions from "../../../store/actions/masterdata.action";
import * as MasterDataSelectors from "../../../store/selectors/masterdata.selector";
import { getSupplierDocumentPropertyValues, getSupplierTax, getSupplierTaxInfoValues, getSupplierTaxPropertyValues, getSupplierTaxValues } from 'app/shared/utils/utils';
import { OnboardingDocumentsService } from 'app/profile/services/onboarding-document.service';

@Component({
  selector: 'app-tax-dialog',
  templateUrl: './tax-dialog.component.html',
  styleUrls: ['./tax-dialog.component.scss']
})
export class TaxDialogComponent extends BaseComponent implements OnInit {
  initialData: SupplierTaxPropertyValues;
  updatedTaxInfo: SupplierTax;

  //  Fields required by the tax-edit form
  countries$: Observable<Country[]>;
  taxCountries$: Observable<TaxCountryConfig[]>;
  currencies$: Observable<Currency[]>;
  taxIdTypes$: Observable<TaxIDType[]>;
  settings$: Observable<GeneralSettings>;
  supplierTax$: Observable<SupplierTaxInfo>;
  supplierTax: SupplierTax;
  supplierTaxInfo: SupplierTaxInfo;
  requiredDocuments: OnboardingDocument[];
  supplierCode: string;

  //  Array of subscriptions to unsubcribe at ngDestroy
  subscriptions: Subscription[] = [];

  supplierTaxDocType: string[] = ['W-2', '1099', 'RFC', 'MXCOMP', 'CORR-T', 'TI'];
  taxDocuments: any;

  //  Reference to the child component so that we can invoke the onSubmit action
  @ViewChild('taxEditComponent', { static: false }) taxEditComponent: TaxEditComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: DataWithSupplierCode<SupplierTaxPropertyValues>,
    public dialogRef: MatDialogRef<TaxDialogComponent>,
    private supplierStore: Store<SupplierProfileState>,
    private taxStore: Store<TaxState>,
    private onboardingDocumentsService: OnboardingDocumentsService
  ) {
    super();
    this.supplierCode = dialogData.suppliercode;
    this.initialData = dialogData.data;
    this.supplierTax = getSupplierTax(this.initialData);
    if(this.supplierTax){
      this.supplierTaxInfo = getSupplierTaxInfoValues(this.supplierTax);
    }
    this.requiredDocuments = [];
  }

  ngOnInit(): void {
    //  Dispatch action to get general settings, countries, currencies and tax id types
    this.supplierStore.dispatch(new GeneralActions.GetGeneralSettings());
    this.supplierStore.dispatch(new MasterDataActions.GetCurrency());
    this.taxStore.dispatch(TaxActions.GetTaxCountries());
    this.taxStore.dispatch(TaxActions.GetTaxIDTypes());

    this.onboardingDocumentsService.getDocumentTypes().subscribe(res => {
      if (res) {
        this.taxDocuments = res.filter(x => x.category == "Tax");

        this.taxDocuments?.forEach(doc => {
          if (!this.supplierTaxDocType.includes(doc.name)) {
            this.supplierTaxDocType.push(doc.name);
          }
        })
      }
    });

    //  Get selectors to query the required data for the tax-edit component
    this.settings$ = this.supplierStore.select(GeneralSelectors.getGeneralSettings);
    this.currencies$ = this.supplierStore.select(MasterDataSelectors.SelectCurrencies);
    this.taxCountries$ = this.supplierStore.select(TaxSelectors.GetTaxCountries);
    this.taxIdTypes$ = this.taxStore.select(TaxSelectors.GetTaxIDTypes);

  }

  /** Handler for when the child components submits tax info with valid data */
  saveHandler(supplierTax: SupplierTaxInfo) {
    if(this.initialData){
      this.supplierTax = new SupplierTax();
    }
    this.updatedTaxInfo = getSupplierTaxValues(supplierTax, this.supplierTax)

    // add uploaded document Info
    var documentsToUpload: SupplierDocument[] = [];
    supplierTax.DocumentInfos.forEach(doc => {
      const document = new SupplierDocument();
      document.Operation = OPERATION.CREATE;
      document.DocumentID = doc.DocumentID;
      document.DocumentType = doc.DocumentType;
      document.FileName = doc.FileName;
      document.DocumentVersion = doc.DocumentVersion;
      document.ReferenceSystem = 'DMS';
      documentsToUpload.push(document);
    });
    this.dialogRef.close([getSupplierTaxPropertyValues(this.updatedTaxInfo, this.initialData), documentsToUpload.map(doc => getSupplierDocumentPropertyValues(doc, null))]);
  }

  /** Handler for cancel event */
  cancelHandler(){
    this.dialogRef.close(null);
  }

  setErrorMessage(){

  }

}
